import OrdersLogDataTable from "../../../../../components/dataTable/custom/canteen/OrdersLogDataTable";

function OrdersLogPageView() {
  return <OrdersLogDataTable />;
}

export default OrdersLogPageView;
